import ReportsAdapter from './base';

export default class ReportFeedback extends ReportsAdapter {
  modelNamePlural = 'report-feedback';
}
